<template>
  <div class="add-remittance-container">
    <div>
      <bread-crumbs
        :page="$t('remittances.addRemittance.breadcrumbMain')"
        :section="$t('remittances.addRemittance.breadcrumbText')"
        :pageClick="openListOfRemittance"
      />
      <div class="spacing-32"></div>
    </div>
    <div>
      <page-header :title="$t('remittances.addRemittance.heading')" />
      <div class="spacing-24"></div>
      <div class="spacing-4"></div>
      <div class="spacing-2"></div>
      <b-row>
        <b-col md="10">
          <remittance-form
            :submitLoading="submitLoading"
            :uploadsSaved="uploadsSaved"
            @addRemittanceAccount="addRemittanceAccount"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/common/PageHeader'
import BreadCrumbs from '@/components/common/BreadCrumbs'
import RemittanceForm from '@/components/remittances/RemittanceForm'
import remittanceService from '@/services/remittance'
import { uploadFilesBus } from '../../main'

export default {
  props: ['prev'],
  errorCaptured: function (err) {
    console.log('Caught error', err.message)
  },
  components: {
    PageHeader,
    RemittanceForm,
    BreadCrumbs
  },
  data() {
    return {
      bankLoading: false,
      submitLoading: false,
      uploadsSaved: [
        {
          index: 0,
          editable: true,
          visible: true,
          vIndex: 0,
          exporter_user_id: '',
          pod_docs: [],
          pci_docs: [],
          pop_docs: [],
          remittance_supporting_document: [],
          errorMessage: ''
        }
      ]
    }
  },
  created() {
    uploadFilesBus.$on('addDocument', this.addDocument)
    uploadFilesBus.$on('removeDocument', this.removeDocument)
    uploadFilesBus.$on('documentRequired', this.documentRequired)
  },
  mounted() {
    this.$mpTrack('Add Remittance - Add Remittance opened')
  },
  computed: {
    getTruncatedBankName() {
      if (this.bank.bank_name) {
        if (this.bank.bank_name && this.bank.bank_name.length > 24) {
          return this.bank.bank_name.slice(0, 24) + '...'
        } else {
          return this.bank.bank_name
        }
      }
      return ''
    }
  },
  methods: {
    documentRequired(show) {
      if (show) {
        this.uploadsSaved[0].errorMessage = this.$t(
          'remittances.addRemittance.uploads.errorMessage'
        )
      } else {
        this.uploadsSaved[0].errorMessage = ''
      }
    },
    addDocument(data) {
      if (data && data.docTag && data.id && this.uploadsSaved[0][data.docTag]) {
        this.uploadsSaved[0][data.docTag].push({
          docId: data.id, // doc id
          id: data.id, // task id
          name: data.name,
          url: data.url,
          tag: data.tag
        })
        this.documentRequired(false)
        this.$mpTrack('Add Remittance - File uploaded (by type)', {
          tag: data.docTag
        })
      }
    },
    removeDocument(documentIndex, docTag, documentId) {
      if (
        documentIndex >= 0 &&
        docTag &&
        this.uploadsSaved[documentIndex][docTag] &&
        documentId
      ) {
        this.uploadsSaved[documentIndex][docTag] = this.uploadsSaved[
          documentIndex
        ][docTag].filter((x) => x.docId !== documentId)
        remittanceService
          .removeDocument(this.$store.getters.accountId, documentId)
          .then((res) => {
            this.$mpTrack('Add Remittance - File removed (by type)', {
              tag: docTag
            })
          })
          .catch((e) => {
            this.$notify({
              title:
                e?.response?.data?.error || this.$t('error.unableToProcess'),
              type: 'error'
            })
          })
      }
    },
    openListOfRemittance() {
      this.$mpTrack(`Add Remittance - Navigate to List of remittance`)
      this.$router.push({ name: 'remittances' })
    },
    addRemittanceAccount(formData) {
      this.$mpTrack(`Add Remittance - Submit Remittance clicked`)
      this.submitLoading = true
      remittanceService
        .addRemittance(formData)
        .then((res) => {
          if (res.data && res.data.message === 'Remittance Added!') {
            this.$mpTrack(`Add Remittance - New remittance payment added`)
            this.submitLoading = false
            this.$notify({
              title: this.$t('remittances.addRemittance.submitSuccess'),
              type: 'success'
            })
            if (res.data.id) {
              this.$router.push({
                name: 'viewRemittance',
                params: {
                  rid: res.data.id,
                  ignoreDialog: true
                }
              })
              return
            }
            this.$router.push({
              name: 'remittances',
              params: {
                ignoreDialog: true
              }
            })
          }
        })
        .catch((e) => {
          this.submitLoading = false
          this.$mpTrack(`Add Remittance - Failed to add remittance payment`, {
            error:
              e?.response?.data ||
              e?.message ||
              this.$t('error.unableToProcess')
          })
          this.$notify({
            title: e?.response?.data?.error || this.$t('error.unableToProcess'),
            type: 'error'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.add-remittance-container {
  padding: 40px 108px;
  @media screen and (max-width: 1200px) {
    padding: 40px 56px;
  }
  @media screen and (max-width: 768px) {
    padding: 40px 24px;
  }
}
</style>
